export const COMMENTS_BREAKPOINT = 1050;
